import { NewsPageQuery } from "@graphql/generated/graphql";
import { t } from "@lingui/macro";
import { NewsArticleJsonLd } from "next-seo";
import { ArticleAuthor } from "next-seo/lib/types";
import { useRouter } from "next/router";

const LumiNewsArticleJsonLd: React.FC<{ data: NewsPageQuery | undefined }> = ({
  data,
}) => {
  const router = useRouter();
  const locale = router.locale || router.defaultLocale;
  const seoLocale = "/" + locale;
  const url: string = `https://luminews.my${
    seoLocale.includes("en") ? "" : seoLocale
  }${router.asPath}`;
  const title: string = data?.news?.title ?? t`Lumi News Malaysia`;
  const description: string =
    data?.news?.description ??
    t`Download the Lumi app to stay updated, get notified when something trends, select topics you want to follow, and share news quickly.`;
  const keywords: string | undefined = data?.news?.topics
    .map((topic) => topic.name)
    ?.join(", ");
  const section: string | undefined =
    (data?.news?.topics.length ?? 0) > 0
      ? data?.news?.topics[0].name
      : undefined;
  const publisherInfo: ArticleAuthor | undefined = data?.news?.newsPublisher
    ? {
        name: data.news.newsPublisher.name,
        url: "https://luminews.my/publishers/" + data.news.newsPublisher.slug,
        type: "Organization",
      }
    : undefined;

  return (
    <>
      <NewsArticleJsonLd
        url={url}
        title={title}
        description={description}
        section={section}
        keywords={keywords}
        authorName={publisherInfo}
        publisherName={publisherInfo?.name}
        isAccessibleForFree={true}
        dateCreated={data?.news?.pubDate}
        thumbnailUrl={data?.news?.thumbnailUrl}
        images={[data?.news?.thumbnailUrl, data?.news?.imageUrl]}
        datePublished={data?.news?.pubDate}
        publisherLogo={data?.news?.newsPublisher.imageUrl}
        body={data?.news?.content || ""}
      />
    </>
  );
};

export default LumiNewsArticleJsonLd;
